// react js base component
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "./FileLocationPopup.scss";
import closeIcon from "../../../assets/svg/Assetmanagemant/closeIcon.svg";
import { useState } from "react";
import { FileLocate_By_Partner } from "../../../api/api";
import { toast } from "react-toastify";
import ErrorPopup from "../../../component/popup/ErrorPopup"; // Adjust path if needed

const FileLocationPopup = ({ show, handleClose, data, assetdetail }) => {
  const [path, setPath] = useState("");
  const [error, setError] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [overridePayload, setOverridePayload] = useState(null);

  function validateVideoPath(path) {
    // Check if empty
    if (!path || path.trim() === "") {
      setError("Path cannot be empty.");
      return false;
    }
    // Simple URL/path format validation
    const pathRegex = /^s3:\/\/[a-z0-9.-]+(\/[a-zA-Z0-9._-]+)*\/?$/;

    if (!pathRegex.test(path)) {
      setError("Invalid path format.");
      return false;
    }

    // Allowed video extensions
    const allowedExtensions = [".mp4", ".mxf", ".mov", ".m3u8", ".mpd"];
    const lowerPath = path.toLowerCase();

    const isValidExtension = allowedExtensions.some((ext) =>
      lowerPath.endsWith(ext)
    );

    if (!isValidExtension) {
      setError("Invalid file type. Must be a video file or package.");
      return false;
    }

    return true;
  }
  function closeModal() {
    setPath("");
    setError("");
    setShowErrorPopup(false);
    setOverridePayload(null);
    handleClose();
  }

  async function handleSelectFile(overrideValue) {
    if (!validateVideoPath(path) && !overrideValue) return;
    let payload = {
      ...data,
      s3Uri: !!overrideValue ? overridePayload.s3Uri : path,
      overrideExisting: !!overrideValue,
    };
    const response = await FileLocate_By_Partner(payload);
    console.log("response", response);
    if (response?.data?.status === true) {
      assetdetail()
      toast.success(
        response.data.message
          ? response.data.message
          : "Asset Ingestion Initiated Successfully",
        {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 5000,
          style: { color: "#333333", fontWeight: "bold" },
        }
      );
      closeModal();
      return;
    } else {
      const message = (response?.data?.message || "").toLowerCase();
      const indicatesAlreadyExists = message.includes("already exist");

      if (indicatesAlreadyExists) {
        closeModal();
        setOverridePayload(payload);
        setShowErrorPopup(true);
        // toast.error("This file already exists. Do you want to override it?", {
        //   position: toast.POSITION.BOTTOM_RIGHT,
        //   autoClose: 5000,
        //   style: { color: "#333333", fontWeight: "bold" },
        // });
        return;
      }
      let msg = response?.data?.message
      if(msg.includes("File does not exist")){
        msg = "Source file does not exist"
      }
      toast.error(
        msg
          ? msg
          : "Something went wrong, please try after sometime",
        {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 5000,
          style: { color: "#333333", fontWeight: "bold" },
        }
      );
    }
  }
  // Handler for confirming override in ErrorPopup
  async function handleOverrideConfirm() {
    if (overridePayload) {
      await handleSelectFile(true); // Call with override = true
      setShowErrorPopup(false);
      setOverridePayload(null);
    }
  }

  return (
    <>
      <Modal show={show} className="FileLocationModal" onHide={closeModal}>
        <Modal.Header>
          <Modal.Title>
            <div className="title">Locate File</div>
          </Modal.Title>
          <div onClick={closeModal} style={{ cursor: "pointer" }}>
            <img src={closeIcon} alt="close" />
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="inputFile">
            <label>Enter the file path </label>
            <input
              type="text"
              placeholder="Enter file path (eg, s3:\\<bucket_name>\<sub-folders>\<filename.ext>)"
              value={path}
              onChange={(e) => {
                setPath(e.target.value);
              }}
            />
            {error && <div className="error-msg">{error}</div>}
          </div>
        </Modal.Body>
        <Modal.Footer className="buttonsSection">
          <Button className="cancel" onClick={closeModal}>
            Cancel
          </Button>
          <Button className="select" onClick={() => handleSelectFile(false)}>
            Select File
          </Button>
        </Modal.Footer>
      </Modal>
      {showErrorPopup && (
        <ErrorPopup
          message="This file already exists. Do you want to override it?"
          closebox={() => setShowErrorPopup(false)}
          overrides={() => {
            handleOverrideConfirm();
          }}
          btntext="Override"
        />
      )}
    </>
  );
};

export default FileLocationPopup;
